import { useHasPermission } from '@/entities/profile';

/**
 * Признак «у сайдбара есть панель помимо навигации», то есть кнопке «Навигация» есть на что
 * переключать. Сейчас такая панель одна — ИИ-агента. Новая панель добавляет своё условие сюда,
 * а не к каждому месту показа переключателя.
 */
export const useHasOtherSidebarPanels = () => {
  const canUseAiAgent = useHasPermission('USE_AI_AGENT');

  return canUseAiAgent;
};
